import { writable, derived } from 'svelte/store'
import Cookies               from 'js-cookie'
import { prefix }            from './api.js'

const loggedIn = Cookies.get(`${prefix}dogma-ls`) || false

const match = /empresa\/([0-9]+)\/?([a-z]*)/.exec(window.location)

export const user       = writable({ loggedIn: loggedIn })
export const companyId  = writable(match ? match[1] : null)
export const account    = writable({})
export const domain     = writable({})
export const appdata    = writable({})
export const processors = writable([])
export const domains    = writable([])
export const dpo        = writable([])
export const settings   = writable({ timezone: 'America/Sao_Paulo' })
appdata.subscribe(value => account      .set(value.account    || {}))
appdata.subscribe(value => processors   .set(value.processors || []))
appdata.subscribe(value => domains      .set(value.domains    || []))
appdata.subscribe(value => settings     .set(value.settings   || {}))

export const companies        = derived(appdata, $appdata => $appdata.companies)
export const company          = derived([companyId , companies], findCompany)
export const companyOptions   = derived(companies  , $companies  => $companies .map(toCompanyOption)  )
export const domainOptions    = derived(domains    , $domains    => $domains   .map(toDomainOption)   )
export const processorOptions = derived(processors , $processors => $processors.map(toProcessorOption))

company.subscribe(updateCompanyCookie)

function updateCompanyCookie(currentCompany) {
    const options = { secure: true, domain: '.dogma.legal' }
    if(currentCompany.dpo) {
        dpo.set(true)
        Cookies.set('dogma-dpo-company', currentCompany.id, options)
    } else {
        dpo.set(false)
        Cookies.remove('dogma-dpo-company', options)
    }
}

export function toCompanyOption(it) {
    return { value: it, id: it.id, text: it.name }
}

export function toDomainOption(it) {
    return { value: it, id: it.id, text: it.domain }
}

export function toProcessorOption(it) {
    return { value: it, id: it.id, text: it.name }
}

function findCompany([id, list]) {
    if(id && list) {
        return list.find(it => it.id == id) || {}
    }
    return {}
}
